import { useEffect, useState } from "react";
import axios from "axios";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import PostCard from "@/components/PostCard";
import useSEO from "@/hooks/useSEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Updates() {
  useSEO({
    title: "Updates & Impact — The Tandem T Foundation",
    description: "The latest drives, milestones, and stories from The Tandem T Foundation.",
    path: "/foundation/updates",
  });
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data || [])).catch(() => setPosts([]));
  }, []);

  return (
    <div data-testid="page-updates">
      <PageHero
        overline="Updates & Impact"
        title={<>Every step, <em className="italic">shared with you.</em></>}
        subtitle="Drives, milestones, and moments from the work — because the people who make it possible deserve to see it happening."
        testId="updates-hero"
      />

      <section className="py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          {posts === null && <p className="text-white/40 font-light">Loading…</p>}
          {posts !== null && posts.length === 0 && (
            <div className="border border-white/12 p-12 text-center" data-testid="updates-empty">
              <p className="font-serif text-2xl font-light text-white">Our story is just beginning.</p>
              <p className="text-white/55 font-light mt-3">Check back soon for our first updates from the field.</p>
            </div>
          )}
          {posts && posts.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="updates-grid">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.06}>
                  <PostCard post={p} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
